// 保存用户信息
export const SAVE_USERBREIF = 'SAVE_USERBREIF';
export const SAVE_ACTIVITY = 'SAVE_ACTIVITY';
export const SAVE_MEDIA_ACCOUNT = 'SAVE_MEDIA_ACCOUNT';
export const SAVE_ROUTER = 'SAVE_ROUTER';
export const SAVE_USERINFO = 'SAVE_USERINFO';
export const SAVE_NOTICE = 'SAVE_NOTICE';